import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http.service';
import { Observable } from 'rxjs/Observable';
import { post } from 'selenium-webdriver/http';

@Injectable()
export class LoginService {

    constructor(
        private http: HttpService
    ) { }

    login(postbody) {
        return this.http.post('api/srm/login', postbody)
            .switchMap(res => this.http.mapRes(res));
    }

    checkUser(postbody) {
        return this.http.post('/api/open/checkUser', postbody)
            .switchMap(res => this.http.mapRes(res));
    }

    acquiryCode(postbody) {
        return this.http.post('api/open/getCheckCode', postbody)
            .switchMap(res => this.http.mapRes(res));
    }

    resetPsd(postbody) {
        return this.http.post('api/open/resetPassword', postbody)
            .switchMap(res => this.http.mapRes(res));
    }

    getCompanyInfo() {
        return this.http.post('api/srm/comapny/getHomePage', {})
            .switchMap(res => this.http.mapRes(res));
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/services/login.service.ts